import { ClientSchemaType } from "../../validations/client";
import { ADD_CLIENT } from "../../endpoints";
import makeAuthenticatedRequest from "../base-api";
import { IClient } from "../../types/brand";

export interface AddClientResponse {
  success: boolean;
  message?: string;
  client?: IClient;
}

export const clientListQueryKey = ['client-list'];

export const addClient = async (data: ClientSchemaType): Promise<AddClientResponse> => {
  const response = await makeAuthenticatedRequest(ADD_CLIENT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to add client");
  }

  const result = await response.json();
  return result.data;
}; 